import { setupLogging } from "./logger";
import { StrictMode } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./vendors.scss";
import "@dbn/omnichannel-design-system-g4p/lib/index.css";
import { ThirdPartyApp } from "./ThirdPartyApp";

setupLogging();

ReactDOM.render(
  <StrictMode>
    <ThirdPartyApp />
  </StrictMode>,
  document.getElementById("root")
);
